import z from 'zod'
import { decimalSchema } from '../../utils/schema'

const depositHistorySchema = z.object({
  /** Record ID */
  id: z.string(),
  /** Hash record of the withdrawal */
  txid: z.string().nullable().optional(),
  /** Client order ID */
  withdraw_order_id: z.string().nullable().optional(),
  /** Operation time */
  timestamp: z.string(),
  /** Token amount */
  amount: decimalSchema,
  /** Currency name */
  currency: z.string(),
  /** Withdrawal address */
  address: z.string(),
  /** Additional memo for withdrawal */
  memo: z.string().nullable().optional(),
  /** Trading Status */
  status: z.union([
    z.literal('REVIEW'),
    z.literal('PEND'),
    z.literal('DONE'),
    z.literal('INVALID'),
    z.literal('TRACK'),
    z.literal('BLOCKED'),
    z.literal('DEP_CREDITED'),
  ]),
  /** Chain name used for withdrawal */
  chain: z.string(),
})

export const responseSchema = z.array(depositHistorySchema)
